import React, { useState, useEffect } from "react";
import { Fade, IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll the page to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Fade in={isVisible}>
      <IconButton
        onClick={scrollToTop}
        variant="contained"
        sx={{
          color: "white",
          backgroundColor: "var(--primary-color)",
          position: "fixed",
          bottom: 30,
          right: 30,
          zIndex: 1000,
          "&:focus, &:active": { outline: "none" },
          "&:hover": {
            color: "white",
            backgroundColor: "var(--primary-color)",
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </IconButton>
    </Fade>
  );
};

export default BackToTopButton;
